
import { roiMetricsData } from "../data/landingPageData";

export const ROIMetricsSection = () => {
  return (
    <div className="py-24 bg-gradient-to-br from-slate-900 to-slate-800">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-4xl text-center">
          <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">
            Proven Results That Drive Growth
          </h2>
          <p className="mt-6 text-lg leading-8 text-slate-300">Estimates from initial testing using BrigAI</p>
        </div>
        
        <div className="mx-auto mt-16 grid max-w-7xl grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {roiMetricsData.map((item, index) => (
            <div key={index} className="text-center">
              <div className="text-5xl font-bold text-red-400 mb-2">{item.metric}</div>
              <div className="text-xl font-semibold text-white mb-1">{item.description}</div>
              <div className="text-sm text-slate-400">{item.subtext}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
